import { useEffect, useState } from "react";
import { isAuthenticated } from "@/common/services/Auth";

export const useIsAuth = () => {
  const [isAuth, setIsAuth] = useState(false);

  useEffect(() => {
    (async () => {
      setIsAuth(await isAuthenticated());
    })();
  });

  return isAuth;
};
